import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import './LoginPage.css';

function LoginPage() {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const location = useLocation();

    const from = location.state?.from?.pathname || "/admin"; // 기본 리디렉션 경로를 /admin으로 변경

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError('');
        
        const formData = new URLSearchParams();
        formData.append('username', username);
        formData.append('password', password);

        try {
            const response = await fetch('/api/login', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: formData.toString()
            });

            if (response.ok) {
                // 로그인 성공 시, 페이지를 새로고침하여 Spring Security가 리디렉션을 처리하도록 함
                window.location.href = from;
            } else {
                setError('로그인 정보가 올바르지 않습니다.');
            }
        } catch (err) {
            setError('로그인 중 오류가 발생했습니다.');
        }
    };

    return (
        <div className="login-container">
            <form onSubmit={handleSubmit} className="login-form">
                <h2>관리자 로그인</h2>
                <div className="input-group">
                    <label htmlFor="username">계정</label>
                    <input
                        id="username"
                        type="text"
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                    />
                </div>
                <div className="input-group">
                    <label htmlFor="password">비밀번호</label>
                    <input
                        id="password"
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                {error && <p className="error-message">{error}</p>}
                <button type="submit">로그인</button>
            </form>
        </div>
    );
}

export default LoginPage;
